// third-party

// assets
import { ControlFilled, UsergroupAddOutlined, GroupOutlined, TeamOutlined, FileTextOutlined } from '@ant-design/icons';
import useAuthContext from 'context/useAuthContext';

// type
import { NavItemType } from 'layout/mantis/types/MenuType';
import { BankOutlined, TagFilled, QuestionCircleOutlined, FormOutlined } from '@ant-design/icons/lib/icons';
import useGlobalContext from 'context/useGlobalContext';

// icons
const icons = {
	controlFilled: ControlFilled,
	bankOutlined: BankOutlined,
	questionCircleOutlined: QuestionCircleOutlined,
	usergroupAddOutlined: UsergroupAddOutlined,
	groupOutlined: GroupOutlined,
	teamOutlined: TeamOutlined,
	tagFilled: TagFilled,
	formOutlined: FormOutlined,
	fileTextOutlined: FileTextOutlined
};

// ==============================|| MENU ITEMS - DASHBOARD ||============================== //

export default function ExamBankMenuItems() {
	const { permissions, roles } = useAuthContext();
	const { activeCompany } = useGlobalContext();
	let items: NavItemType = {};

	if (permissions) {
		if (
			permissions.some((el: string) => {
				return el === 'View_Exams' || el === 'Manage_Exams' || el === 'Base_Setting';
			})
		) {
			items = {
				id: 'group-exam-bank',
				title: 'Exam',
				type: 'group',
				icon: icons.bankOutlined,
				children: []
			};

			if (
				permissions.some((el: string) => {
					return el === 'View_Exams';
				})
			) {
				items.children.push({
					id: 'core-exam-bank-list-question',
					title: 'Questions Bank',
					type: 'item',
					url: '/app/exam/bank/list/questions',
					icon: icons.questionCircleOutlined,
					breadcrumbs: true
				});
			}
			if (
				permissions.some((el: string) => {
					return el === 'Manage_Exams' || el === 'View_Exams';
				})
			) {
				items.children.push({
					id: 'core-exam-bank-list-exam',
					title: 'Exam',
					type: 'item',
					url: '/app/exam/bank/list/exams',
					icon: icons.bankOutlined,
					breadcrumbs: true
				});
				items.children.push({
					id: 'core-exam-bank-list-exam-retake',
					title: 'Exam - Retakes',
					type: 'item',
					url: '/app/exam/bank/list/exams/retakes',
					icon: icons.bankOutlined,
					breadcrumbs: true
				});
				items.children.push({
					id: 'core-assignment-bank-list',
					title: 'Assignments Bank',
					type: 'item',
					url: '/app/assignment/bank/list/assignments',
					icon: icons.fileTextOutlined,
					breadcrumbs: true
				});
				items.children.push({
					id: 'core-batch-assignment-list',
					title: 'Batch Assignments',
					type: 'item',
					url: '/app/assignment/bank/list/batch-assignments',
					icon: icons.bankOutlined,
					breadcrumbs: true
				});
			}


			if (activeCompany.value == null) {
				if (
					permissions.some((el: string) => {
						return el === 'Base_Setting';
					})
				) {
					let exam_setting = {
						id: 'core-setting-exam',
						title: 'Exam Settings',
						type: 'collapse',
						icon: icons.formOutlined,
						breadcrumbs: true,
						children: []
					};

					exam_setting.children.push({
						id: 'core-setting-exam-answer-type',
						title: 'Answer Type',
						type: 'item',
						url: '/app/settings/exam/answer/types',
						breadcrumbs: true
					});

					exam_setting.children.push({
						id: 'core-setting-exam-question-type',
						title: 'Question Type',
						type: 'item',
						url: '/app/settings/exam/question/types',
						breadcrumbs: true
					});

					exam_setting.children.push({
						id: 'core-setting-exam-type',
						title: 'Exam Type',
						type: 'item',
						url: '/app/settings/exam/types',
						breadcrumbs: true
					});

					items.children.push(exam_setting);
				}
			}
			// if (activeCompany.value == null) {
				if (
					permissions.some((el: string) => {
						return el === 'Base_Setting';
					})
				) {
					let assessment_setting = {
						id: 'core-setting-assessment',
						title: 'Assessment Settings',
						type: 'collapse',
						icon: icons.formOutlined,
						breadcrumbs: true,
						children: []
					};

					assessment_setting.children.push({
						id: 'core-setting-assessment-criteria',
						title: 'Assessment Criteria',
						type: 'item',
						url: '/app/settings/assessment/criterias',
						breadcrumbs: true
					});

					items.children.push(assessment_setting);
				}
			// }
		}
	}

	return items;
}
